<app-table
  [cols]="cols"
  [elements]="elements"
  [lazy]="false"
  [modelName]="modelName"
  [showHeader]="showHeader"
  [showTitle]="showTitle"
  [exportPdf]="exportPdf"
  [addButton]="addButton"
  [dropdownFilters]="dropdownFilters"
  *ngIf="cols && elements"
/>
